import capitalize from 'lodash/capitalize';
import { TextAlignTypes, TextAlignOptionsParams } from '@/types/dashboards/widget.types';

// List of available text align functionality.
export const TEXT_ALIGNMENTS_CONFIG: Array<TextAlignTypes> = ['left', 'center', 'right'];

// List of TipTap nodes where text align attribute should apply.
export const TEXT_ALIGNMENT_TYPES_CONFIG: Array<string> = ['heading', 'paragraph', 'listItem'];

export const TEXT_ALIGNMENT_OPTIONS: Array<TextAlignOptionsParams> = TEXT_ALIGNMENTS_CONFIG.map((alignment) => ({
    id: alignment,
    label: `${capitalize(alignment)} align`,
    icon: {
        type: `align-${alignment}`,
        size: '18',
    },
}));

export const DEFAULT_TEXT_ALIGN = TEXT_ALIGNMENT_OPTIONS[0];
